export const quoteAction = {
  signedDocUpload: { id: -12, code: "SIGNEDDOCUPLOAD" },
  docsToCustomer: { id: -11, code: "DOCTOCUST" },
  viewQuote: { id: -10, code: "VWQUOTE" },
  cancel: { id: -9, code: "CANCEL" },
  decline: { id: -8, code: "DECLINE" },
  fund: { id: -7, code: "FUND" },
  approve: { id: -6, code: "APPROVE" },
  completeDataDoc: { id: -5, code: "CMPDATANODOC" },
  infoDocUpload: { id: -4, code: "INFODOCUPLOAD" },
  completeData: { id: -3, code: "CMPDATA" },
  selectProduct: { id: -2, code: "SELPROD" },
  createQuote: { id: -1, code: "NEWQUOTE" },
};

export const getQuoteDefaultPath = (quoteId, nextActionId) => {
  switch (nextActionId) {
    case quoteAction.selectProduct.id: {
      return `/quotes/${quoteId}/products`;
    }
    case quoteAction.completeData.id:
    case quoteAction.infoDocUpload.id: {
      return `/quotes/${quoteId}/datacompletion`;
    }
    case quoteAction.docsToCustomer.id:
    case quoteAction.signedDocUpload.id:
    case quoteAction.viewQuote.id: {
      return `/quotes/${quoteId}/contract`;
    }
  }
};
